//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { TeacherCalendarPreferencesDisplayItem } from './TeacherCalendarPreferencesDisplayItem';
import { TeacherEmailPreferencesDisplayItem } from './TeacherEmailPreferencesDisplayItem';
import { TeacherAttendancePreferencesDisplayItem } from './TeacherAttendancePreferencesDisplayItem';
import { EventColorEnum } from './Enums';

export class TeacherPreferencesDisplayItem extends ItemBase {  // OBSOLETE - Use only for compatibility
    AllowPracticeLogEmail: boolean = false;
    AutoCompleteExpenses: boolean = false;
    CalendarPreferences: TeacherCalendarPreferencesDisplayItem | null = null;
    DefaultEventCategoryID: string | null = null;
    DefaultLessonDuration: number = 0;
    DefaultLessonPrice: number = 0;
    EmailNotificationPreferences: TeacherEmailPreferencesDisplayItem | null = null;
    EventColor: EventColorEnum = EventColorEnum.Beach;
    HomePagePreferences: TeacherAttendancePreferencesDisplayItem | null = null;
    PreferredLessonLocationID: string | null = null;
    TeacherID: string | null = null;
    TimePickerMinuteStep: number = 0;
    ZoomMeetingURL: string | null = null;

    constructor(initializer?: Partial<TeacherPreferencesDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "TeacherPreferencesDisplayItem";
}
